import { PaginationRequestType } from '../../../types/paginationRequestType';

export enum SurveyContext {
  TeacherEvaluationForStudents = 'teacher-evaluation-for-students',
  CourseEvaluationForTeachers = 'course-evaluation-for-teachers',
}

export const surveyContextTexts = {
  [SurveyContext.TeacherEvaluationForStudents]:
    'Encuesta de curso para estudiantes',
  [SurveyContext.CourseEvaluationForTeachers]:
    'Encuesta por Curso para Docentes',
} as const;

export enum SurveyStatus {
  Published = 'published',
  Finished = 'finished',
}

export const surveyStatusTexts = {
  [SurveyStatus.Published]: 'Publicada',
  [SurveyStatus.Finished]: 'Finalizada',
} as const;

interface Period {
  id: number;
  periodTypeId: string;
  moodleCategoryId: number;
  code: string;
  name: string;
  description: string | null;
  creditMin: number;
  creditMax: number;
  startDate: string;
  endDate: string;
  academicYear: number;
  lastLoadDate: string;
  loadingDeadline: string | null;
  uploadDateSectionAttributes: string;
  sectionAttributesUploadDeadline: string | null;
  createdAt: string;
  updatedAt: string;
  active: boolean;
}

export interface Survey {
  id: number;
  title: string;
  context: string;
  periodName: string;
  startDate: string;
  endDate: string;
  status: 'published' | 'finished';
  fullness: string;
}

export type SurveyResponseType = PaginationRequestType<Survey>;

interface FormData {
  periods: Period[];
  surveyContexts: { id: SurveyContext; name: string }[];
  surveyStatuses: { id: string; name: string }[];
}

export type FormDataResponseType = FormData;
